<template>
  <div class="cargolist">
    <m-title :titlelist="listitem"></m-title>
    <div class="southcargonn">
      <div class="bigbox">
        <div class="southcargo_top">
          <!-- <columnper :itemper="jihua" :amount="alldun"></columnper> -->
          <div class="steer">计划号：{{ datamsg.pno }}</div>
          <div class="southcargo_top_content">
            <ul>
              <el-tooltip  effect="dark" :content="datamsg.agentname||'-'" placement="top">
                <li>货物来源：{{ datamsg.agentname }}</li>
              </el-tooltip>
              <li>船名:{{ datamsg.shipname }}</li>
              <li>作业场地：{{ changdi[datamsg.stname] }}</li>
              <li>未作业车辆:{{ datamsg.carUnWorkedCount }}辆</li>
            </ul>
            <ul>
              <!-- <li>计划状态：{{ datamsg.customname }}</li> -->
              <el-tooltip  effect="dark" :content="datamsg.customname||'-'" placement="top">
                <li>货主：{{ datamsg.customname }}</li>
              </el-tooltip>
              <li>货物名称：{{ datamsg.goodsname }}</li>
              <li>作业垛位：{{ changdi[datamsg.stname] }}</li>
              <li>已作业车辆:{{ datamsg.carWorkdedCount ||0}}辆</li>
            </ul>
            <ul>
              <!-- <li>计划类型：{{ datamsg.plantype }}</li> -->
              <el-tooltip  effect="dark" :content="datamsg.agentname||'-'" placement="top">
                <li>代理：{{ datamsg.agentname }}</li>
              </el-tooltip>
              
              <li>计划吨数：{{ datamsg.plantons  }}吨</li>
              <li>作业进度：{{ datamsg.workProcess }}</li>
            </ul>

            <ul>
              <li>开放状态： {{ datamsg.isopen==0?'开放':'不开放' }}</li>
              <li>剩余吨数：{{ datamsg.surplusDun }}吨</li>
              <el-tooltip  effect="dark" :content="getSimpleDate(new Date(datamsg.startworkdate))||'-'" placement="top">
                <li>
                  开始作业日期:
                  {{ getSimpleDate(new Date(datamsg.startworkdate)) }}
                </li>
              </el-tooltip>
            </ul>
            <ul>
              <li>已派车：{{ datamsg.carTotalCount ||0}}辆</li>
              <li>完成吨数：{{ datamsg.workedDun }}吨</li>
              <el-tooltip  effect="dark" :content="getSimpleDate(new Date(datamsg.endworkdate))||'-'" placement="top">
                <li>
                  结束作业日期：
                  {{ getSimpleDate(new Date(datamsg.endworkdate)) }}
                </li>
              </el-tooltip>
              
            </ul>
          </div>
        </div>
        <div class="southcargo_bot">
          <div class="list_title">
            <div class="button-left">
              <span >车牌号</span>
              <div class="select_boxs">
                <input
                  type="text"
                  placeholder="请输入"
                  v-model="selectitem.plate"
                  clearable
                />
              </div>

              <span >作业节点</span>
              <div class="select_box1">
                <m-select
                  :list="selectastrict2"
                  :value="selectVal"
                  @input="chanval"
                  isObj
                ></m-select>
              </div>
              <span>充电开始时间</span>
              <div class="select_box">
                <el-date-picker
                  v-model="selectitem.starttime"
                  type="date"
                  placeholder="选择日期时间"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
                至
                <el-date-picker
                  v-model="selectitem.endtime"
                  type="date"
                  placeholder="选择日期时间"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="button-right">
              <button @click="gettablelist">查询</button>
              <button class="button1" @click="printList">导出</button>
            </div>
          </div>
          <div class="tablebox">
            <el-table height="90%" :data="tablelist.list" style="width: 100%; ">
              <el-table-column
                show-overflow-tooltip
                label="序号"
                type="index"
                width="50px"
              ></el-table-column>
              <el-table-column prop="pno" label="计划编号" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
              <el-table-column prop="shortname" label="车队名称" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="plate" label="车牌号" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
              <el-table-column prop="guobangcount" label="车次" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="roughWeight" label="毛重总数(吨)" show-overflow-tooltip :render-header="renderHeader">
                  <template v-slot="res">
                    <div>
                      {{ res.row.roughWeight?res.row.roughWeight/1000:'-' }}
                    </div>
                  </template>
              </el-table-column>
              <!-- <el-table-column prop="tare" label="皮重(吨)" show-overflow-tooltip :render-header="renderHeader"> </el-table-column> -->
              <el-table-column prop="suttle" label="净重总数(吨)" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="res">
                    <div>
                      {{ res.row.suttle?res.row.suttle/1000:'-' }}
                    </div>
                  </template>
              </el-table-column>
              <el-table-column prop="shipname" label="船名" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
              <el-table-column prop="cargoname" label="货类" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
              <el-table-column prop="customname" label="货主" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
              <el-table-column prop="xiahuozhi" label="分票号" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
              <el-table-column prop="tidan" label="提单号" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
              <!-- <el-table-column label="审核时间" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.checkedtime, '年月日') }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column prop="reservationPeriod" label="预约时段">
              </el-table-column> -->
              <!-- <el-table-column label="进卡口时间" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.instoredate, '年月日') }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="装车时间">
                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.loaddate, '年月日') }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="过重时间" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.mwitemdate, '年月日') }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="车辆状态" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="res">
                  <div v-for="(item,index) in statusList" :key="index">
                    <div v-if="item.value==res.row.status">{{ item.text }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="回皮时间" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.pwitemdate, '年月日') }}</span>
                </template>
              </el-table-column>
              
              <el-table-column label="出卡口时间" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="res">
                  <span>{{
                    mydateFormat(res.row.outstoredate, '年月日')
                  }}</span>
                </template>
              </el-table-column> -->
            </el-table>
            <div class="paging">
              <el-pagination
                :page-size="selectitem.limit"
                layout="total,prev, pager,next, jumper"
                :total="tablelist.totalCount"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <table
      class="tableprint"
      ref="tablelist"
      style="width: 99%; margin: 10px 0.5%; border-collapse: collapse"
    >
      <tr>
        <th style="border: 1px solid">代理名称</th>
        <th style="border: 1px solid">车牌号</th>
        <th style="border: 1px solid">毛重</th>
        <th style="border: 1px solid">皮重</th>
        <th style="border: 1px solid">净重</th>
        <th style="border: 1px solid">过重时间</th>
      </tr>
      <template v-for="item in tabledata">
        <tr :key="item.id">
          <td style="border: 1px solid; text-align: center">
            {{ item.fleetname }}
          </td>
          <td style="border: 1px solid; text-align: center">
            {{ item.plate }}
          </td>
          <td style="border: 1px solid; text-align: center">
            {{ item.roughWeight }}
          </td>
          <td style="border: 1px solid; text-align: center">{{ item.tare }}</td>
          <td style="border: 1px solid; text-align: center">
            {{ item.suttle }}
          </td>
          <td style="border: 1px solid; text-align: center">
            {{ item.mwitemdate }}
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle';
import mChebox from '@/components/mChebox.vue';
import columnper from '@/components/columnper';
import mSelect from '@/components/mSelect.vue';
import { printExcel } from '@/plugins/other.js';
import {mixins} from '@/mixin/index.js'
import changdi from "@/plugins/changdi.json"
export default {
  name: 'cargoinfo',
  data() {
    return {
      listitem: ['货场管理', '南货场', '计划列表'],
      datamsg: {},
      checked: 0,
      jihua: 0,
      datevalue: '', //开始结束时间
      alldun: 1,
      pno: '',
      selectitem: {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        order: null, //asc升序 dsc倒叙
        sidx: null, //排序字段
        params: null,
        pno: '',
        endtime: '',
        plate: '',
        starttime: '',
        status: '',
      },
      changdi:changdi,
      tablelist: {},
      tabledata: [],
      timeout: null,
      checked: false,
      selectVal: '全部',
      selectastrict2: [
        {
          status: null,
          val: '全部',
        },
        {
          status: 0,
          val: '进行中',
        },
        {
          status: 1,
          val: '完成',
        },
        {
          status: 2,
          val: '暂停',
        },
        {
          status: 3,
          val: '作废',
        },
      ], //作业节点
      // 开始时间
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      value1: '',
      value2: '',
    };
  },
  components: {
    mTitle,
    columnper,
    mChebox,
    mSelect,
  },
  created() {
    this.getinfomsg();
  },
  mixins:[mixins],
  methods: {
    //通过时间戳转换具体时间
    getSimpleDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s;
    },
    async getinfomsg() {
      // console.log(this.$route.params.id);
      // let pno=this.$route.params.id
      const { data } = await this.$http(
        'api1',
        '/fleet/plan/pcPlanDetailByPno',
        'get',
        { pno: this.$route.params.id }
      );
      // console.log(data);
      if (!data||data.code != 0 ||data.data==null) return 
      this.datamsg = data.data;
      this.jihua = data.data.sumSullte  || 0;
      this.alldun = data.data.plantons  || 1;
      this.gettablelist();
    },
    // 表格数据的获取
    async gettablelist(starttime = '', endtime = '') {
      this.selectitem.params = this.datamsg.params || null;
      this.selectitem.pno = this.datamsg.pno || null;
      const { data } = await this.$http(
        'api1',
        '/driver/dispatchtruck/planDispatchTruckList',
        'get',
        this.selectitem,
        {
          starttime: starttime,
          endtime: endtime,
        }
      );
      if (data.code != 0) return console.log('获取表格数据失败');
      this.tablelist = data.data;
    },
    exportlist() {
      if (!this.datamsg.pno) return '';
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async (_) => {
        const { data } = await this.$http(
          'api1',
          '/driver/dispatchtruck/exportPlanDispatchTruckList',
          'get',
          { pno: this.datamsg.pno }
        );
        if (!data) return;
        this.tabledata = data.data;
        this.$nextTick((_) => {
          this.$print(this.$refs.tablelist);
        });
      }, 300);
    },
    handleCurrentChange(index) {
      if (this.tablelist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.gettablelist();
    },
    // 导出
    printList() {
      printExcel.call(
        this,
        '/driver/dispatchtruck/exportDispatchTruckListByPno',
        '派车列表导出',
        this.selectitem,
        'get'
      );
    },
    chanval(data) {
      this.selectitem.status = data.status;
      this.selectVal = data.val;
    },
  },
};
</script>
<style lang="scss" scoped>
.cargolist {
  position: relative;
  height: 100%;

  .select_box1 {
    display: inline-block;
    font-size: 80%;
    font-weight: 400;
    height: 31px;
    margin-top: 14px;
    vertical-align: middle;
    margin-left: 10px;
    background-color: #f3f4f5;
  }
  .select_box {
    display: inline-block;
    font-size: 80%;
    font-weight: 400;
    height: 55px;
    vertical-align: middle;
    margin-left: 10px;
  }
  .southcargonn {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    .bigbox {
      position: relative;
      box-sizing: border-box;
      height: 100%;
      .southcargo_top {
        position: relative;
        box-sizing: border-box;
        height: 35%;
        border-radius: 2px;
        background: #ffffff;
        padding: 10px;
        overflow: auto;
        margin: 10px;
        border-radius: 20px;
        overflow: hidden;
        .steer {
          margin-left: 31px;
          margin-top: 5px;
        }
        .southcargo_top_content {
          font-size: 80%;
          display: flex;
          justify-content: space-around;
          ul {
            line-height: 45px;
            width: 18%;
            li {
              padding: 0;
              margin: 0;
              width: 80%;
              list-style: none;
              white-space: nowrap; 
              overflow: hidden;
              text-overflow:ellipsis;
            }
          }
         
        }
      }
      .southcargo_bot {
        position: absolute;
        box-sizing: border-box;
        top: 40%;
        margin-left: 20px;
        padding: 10px;
        border-radius: 20px;
        bottom: 0;
        width: 98%;
        overflow: auto;
        overflow: auto;
        background: #ffffff;
        .list_title {
          height: 45px;
          line-height: 55px;
          font-size: 100%;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          .button-left {
            display: flex;
            height: 45px;
            line-height: 55px;
            input {
              padding-left: 10px;
              width: 130px;
              height: 30px;
              outline: none;
              border: none;
              background: #f3f4f5;
              border-radius: 2px;
            }
          }
          .button-right {
            display: flex;
            margin-top: 16px;
            margin-right: 20px;
          }

          button {
            width: 80px;
            height: 30px;
            background: #17b6a1;
            border-radius: 8px;
            border: none;
            color: #fff;
            margin-left: 20px;
          }
          .button1 {
            width: 80px;
            height: 30px;
            background: #f5f6fa;
            border-radius: 8px;
            border: none;
            color: #17b6a1;
            margin-left: 20px;
          }
        }
        .tablebox {
          position: absolute;
          top: 80px;
          bottom: 0;
          width: 100%;
          overflow: hidden;
          .paging {
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 30px;
            text-align: center;
          }
        }
      }
    }
  }
  .tableprint {
    display: none;
  }
}
</style>
